import { fromBackend } from '@utils/map-date/from-backend';
import moment from 'moment';
export const isEventScheduled = (isPublished: boolean, scheduledAt: number | null, timezone: string) =>
  scheduledAt !== null && !(isPublished && moment().tz(timezone) > fromBackend(scheduledAt, timezone));
